var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","max-width":`${_vm.modalWidth}px`},model:{value:(_vm.getModalState),callback:function ($$v) {_vm.getModalState=$$v},expression:"getModalState"}},[_c('div',{staticClass:"modal modal__container"},[_c('div',{staticClass:"modal__container_content"},[_c(_vm.modalName,{tag:"component"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }